import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ConnectUserType, sendMessageToWorker } from 'helpers'
import { authenticateUser } from 'helpers/authActionHelpers'
import { AuthMethodType, AuthSliceNamesEnum } from 'storeTypes'

export const loginAction = createAsyncThunk(
    AuthSliceNamesEnum.AUTH_LOGIN,
    async (authMethod: AuthMethodType, thunkAPI) => {
        const userState = await authenticateUser(authMethod)
        sendMessageToWorker({ 'sync open tabs': '' })
        if (userState.statusCode >= 400) {
            return thunkAPI.rejectWithValue(userState)
        }
        return userState
    }
)

type AuthResponseType = {
    message: string
    statusCode: number
    user?: ConnectUserType
}

type AuthState = {
    loggingIn?: boolean
    loggedIn?: boolean
    response?: AuthResponseType
}

const initialState: AuthState = {}

const authSlice = createSlice({
    name: AuthSliceNamesEnum.AUTH,
    initialState,
    reducers: {
        logout: () => ({})
    },
    extraReducers: (builder) => {
        builder
            .addCase(loginAction.pending, (state) => {
                state.loggingIn = true
            })
            .addCase(
                loginAction.fulfilled,
                (state, action: PayloadAction<AuthResponseType>) => {
                    state.loggingIn = false
                    state.loggedIn = true
                    state.response = action.payload
                }
            )
            .addCase(loginAction.rejected, (state, action) => {
                state.loggingIn = false
                state.loggedIn = false
                state.response = action.payload as AuthResponseType | undefined
            })
    }
})

export const { logout } = authSlice.actions
export const authReducer = authSlice.reducer
